export class MfeConfiguration {
  private static _url: string;

  public static get url() {
    return this._url;
  }

  public static set url(url: string) {
    this._url = url;
  }
}
